'use client';

import { useState } from 'react';
import PropTypes from 'prop-types';
import ResultRow from './ResultRow';

/** Result rows, a page at a time, with "Show more" underneath. */
export default function ResultsList({ rows, pageSize }) {
  const [shown, setShown] = useState(pageSize || rows.length);
  const left = rows.length - shown;
  return (
    <>
      <ul className="mt-8 lg:mt-12 border-t-2 border-ink">
        {rows.slice(0, shown).map((r) => (
          <ResultRow key={r.key} r={r} />
        ))}
      </ul>
      {left > 0 && (
        <button
          type="button"
          onClick={() => setShown((n) => n + pageSize)}
          className="btn-block btn-line-ink mt-8"
        >
          Show {Math.min(left, pageSize)} more
        </button>
      )}
    </>
  );
}

ResultsList.propTypes = {
  rows: PropTypes.array.isRequired,
  pageSize: PropTypes.number,
};
